import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

const base_api_url = "korankirimanrevisi";

export default {

    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'code', 'name', 'nofaktur', 'revisigrpKey','codenama','uraian'];
                const keys = ['page', 'limit', 'sortBy', 'sortDir','customer_id', 'CustName', 'tgl1', 'tgl2', 'tglR1', 'tglR2', 'revisigrpKey', 'kota_id', 'kota_name', 'customer_group', 'no_revisi', 'createby', 'salesae_id', 'salesae_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.revisi_qty = meta.revisi_qty;
                obj.revisi_val = meta.revisi_val;

                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`/${base_api_url}`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/${base_api_url}/detail/${obj.revisiKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/${base_api_url}/${obj.revisiKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                // const keys = ['sortBy', 'sortDir', 'tgl1', 'tgl2', 'code', 'name', 'nofaktur', 'revisigrpKey','codenama','uraian'];
                const keys = ['page', 'limit', 'sortBy', 'sortDir','customer_id', 'CustName', 'tgl1', 'tgl2', 'tglR1', 'tglR2', 'revisigrpKey', 'kota_id', 'kota_name', 'customer_group', 'no_revisi', 'createby', 'salesae_id', 'salesae_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/${base_api_url}/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'revisi_aktual_kiriman.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}